/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WhenInputs */

const de__field_when = /** @type {(inputs: _Field_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann`)
};

/**

* @param {_Field_WhenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_when = /** @type {((inputs?: _Field_WhenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WhenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_when(inputs)
});